import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { param2Obj } from '@/tool/index'
import { setGrpid, setToken } from '@/tool/auth.js'

import nurse from './data/nurse.js'
import operation from './data/operation.js'

Vue.use(Router)
let router = new Router({
  routes: [
    ...nurse,
    ...operation,
    {
      path: '*',
      redirect: '/login'
    }
  ],
  scrollBehavior: () => ({ y: 0 }) // 跳转滚动到顶部
})
const whiteList = ['/login'] // 路由的白名单
let isLogin = false // 登录状态
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title
  const params = param2Obj(window.location.href)
  console.log('params: ', params)
  // 判断请求头是否有登录信息且不在白名单
  if (params.token && params.grpid && params.ProductType && whiteList.indexOf(to.path) == -1 && !isLogin) {
    setToken(params.token)
    console.log(123)
    localStorage.setItem('active', params.ProductType) //判断是医生还是护士
    localStorage.setItem('isApp', 0) //是否隐藏头部 0为隐藏 1为显示
    try {
      await store.dispatch('login', { token: params.token, comId: params.grpid })
      isLogin = true
    } catch (error) {
      next(`/login`)
    }
  }

  /* 路由发生变化修改页面title */
  // 登录了
  if (store.state.user) {
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
    next()
  } else {
    // 未登录
    // 白名单
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js